import React from 'react';

import { getMatchDraw } from '../../../utils/events';

const OOPMatchCard = ({ teamsDict, playersDict, match, draws }) => {
    const matchDraw = getMatchDraw(match, draws);
    const formatPlayerName = (matchPosition) => {
        if (matchPosition?.type?.value === 'team' && matchPosition.type?.value === 'team') {
            const team = teamsDict[matchPosition.id];

            return team?.displayName;
        }

        const player = playersDict[matchPosition?.id];
        const nationality = player?.nationality ? `(${player?.nationality})` : '';

        if (player) {
            return `${player?.displayName} ${nationality}`;
        }
        return 'TBD';
    };

    const renderRound = () => {
        const matchRound = matchDraw?.rounds?.findIndex(round => round.matches.some(roundMatch => roundMatch.id === match.id));

        return `Round (R${matchRound + 1})`;
    };

    return (
        <div id="oop-match-card" className="text-center print utr-card oop-match-card bg-white">
            <div className="time">{match.timeLabel || ' '}</div>
            <div className="player">{formatPlayerName(match.position1)}</div>
            <div className="vs">vs</div>
            <div className="player">{formatPlayerName(match.position2)}</div>
            {matchDraw?.parentDrawName && <div className="draw-name">{matchDraw?.parentDrawName}</div>}
            <div className="draw-name">{matchDraw?.name} - {renderRound()}</div>
        </div>
    );
};

const Court = (props) => {
    const {
        columnNumber,
        court,
        ...restProps
    } = props;

    return (
        <div className={`col-12 col-md-4 d-md-block ${`round${columnNumber}`}`}>
            <div className="section-header text-small text-medium text-center text-dark mb24">
                {court?.name}
            </div>
            <div className="spacer" />
            {court.matches.map((match) => {
                return (
                    <OOPMatchCard
                        match={match}
                        {...restProps}
                    />
                );
            })}
        </div>
    );
};

export default Court;
